import React, { useState } from "react";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../redux/usersSagas";
import { SearchInput } from "../../../../components/form/Input/Input";

const filterByOptions = [
  { id: "type", name: "User Type" },
  { id: "multiple", name: "Role/Organization/Type" },
  { id: "locations", name: "Location Access" },
  { id: "search", name: "User Name or Email" }
];

const dropdownSettings = {
  type: "user_type",
  locations: "selected_store_ids",
  search: "search_request"
};

export default function FilterUsers() {
  const dispatch = useDispatch();
  const {
    filters: { organizations, roles, types, locations }
  } = useSelector((state) => state.users.commonSettings);

  const firstTypes = types.slice(0, 2);
  const restTypes = types.slice(2);

  const [selectedFilterByOption, setSelectedFilterByOption] = useState(null);

  const [currentFilter, setCurrentFilter] = useState({ type: null, data: null });

  const [multipleFilters, setMultipleFilers] = useState({
    organization_ids: [],
    role_id: null,
    user_type: null
  });

  const onFilterByChange = (data) => {
    setMultipleFilers({
      organization_ids: [],
      role_id: null,
      user_type: null
    });

    if (selectedFilterByOption && selectedFilterByOption.id == data.id) {
      setSelectedFilterByOption(null);
      setCurrentFilter({ type: null, data: null });
      return;
    }

    setSelectedFilterByOption(data);
    setCurrentFilter({ type: data.id, data: null });
  };

  const onChange = (data, type) => {
    setCurrentFilter({ data, type });
  };

  const onMultipleChange = (data, type) => {
    if (type === "organization_ids") {
      setMultipleFilers((prev) => ({ ...prev, [type]: data }));
      return;
    }

    setMultipleFilers((prev) => ({
      ...prev,
      [type]: multipleFilters[type]?.id === data.id ? null : data
    }));
  };

  const onUpdate = () => {
    if (currentFilter.type === "multiple") {
      dispatch(fetchUsers({ key: "multiple", data: multipleFilters }));
      return;
    }
    dispatch(fetchUsers({ key: [dropdownSettings[currentFilter.type]], data: currentFilter.data }));
  };

  return (
    <div className="admin-users__filters">
      <div className="admin-users__filterBy">
        <p>Filter By:</p>
        <Dropdown
          height={275}
          haveOnSelectChange
          placeholder="Please choose filter type"
          options={filterByOptions}
          selectedFilters={selectedFilterByOption}
          numberDisplayed={1}
          onSelectChange={onFilterByChange}
        />
      </div>
      <div className="admin-users__filters-dynamic">
        {selectedFilterByOption && (
          <>
            {selectedFilterByOption.id == "type" && (
              <Dropdown
                height={275}
                haveOnSelectChange
                placeholder="Please choose user type"
                options={firstTypes}
                selectedFilters={currentFilter.data}
                numberDisplayed={1}
                onSelectChange={(data) => onChange(data, "type")}
              />
            )}

            {selectedFilterByOption.id == "locations" && (
              <Dropdown
                height={275}
                haveOnSelectChange
                includeSelectAll
                placeholder="Please choose location"
                enableOnly
                options={locations}
                selectedFilters={currentFilter.data ?? []}
                numberDisplayed={0}
                onSelectChange={(data) => onChange(data, "locations")}
              />
            )}
            {selectedFilterByOption.id == "search" && (
              <div className="search">
                <SearchInput
                  placeholder="Search..."
                  value={currentFilter.data ?? ""}
                  onChange={(value) => onChange(value, "search")}
                  onClear={() => setCurrentFilter((prev) => ({ ...prev, data: "" }))}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && currentFilter.data) {
                      onUpdate();
                    }
                  }}
                />
              </div>
            )}
          </>
        )}
      </div>

      {selectedFilterByOption && selectedFilterByOption.id == "multiple" && (
        <div className="admin-users__filters-multiple">
          <Dropdown
            height={275}
            haveOnSelectChange
            placeholder="Please choose role"
            options={roles}
            selectedFilters={multipleFilters.role_id}
            numberDisplayed={0}
            onSelectChange={(data) => onMultipleChange(data, "role_id")}
          />
          <Dropdown
            includeSelectAll
            enableOnly
            height={275}
            haveOnSelectChange
            placeholder="Please choose organization"
            options={organizations}
            selectedFilters={multipleFilters.organization_ids}
            numberDisplayed={0}
            onSelectChange={(data) => onMultipleChange(data, "organization_ids")}
          />
          <Dropdown
            height={275}
            haveOnSelectChange
            placeholder="Please choose user type"
            options={restTypes}
            selectedFilters={multipleFilters.user_type}
            numberDisplayed={0}
            onSelectChange={(data) => onMultipleChange(data, "user_type")}
          />
        </div>
      )}
      {(currentFilter.data ||
        multipleFilters.role_id ||
        multipleFilters.user_type ||
        multipleFilters.organization_ids.length >= 1) && (
        <button className="button button--primary" onClick={onUpdate}>
          Update
        </button>
      )}
    </div>
  );
}
